import React, { Component } from 'react';
import './App.css';
import * as layerInfoHelpers from './helpers';
import * as helpers from '../helpers/helpers';

import mainConfig from './config.json';
import ReactGA from 'react-ga4';

const enableAnalytics = helpers.getURLParameter('ANALYTICS') !== 'off';
// if (mainConfig.googleAnalyticsID !== undefined && mainConfig.googleAnalyticsID !== "" && enableAnalytics) {
//   ReactGA.initialize(mainConfig.googleAnalyticsID);
//   ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
// }

// THIS APP ACCEPTS A FULL URL TO GEOSERVER LAYER
// E.G.  https://url/geoserver/rest/workspaces/gracanica/datastores/paradise/featuretypes/Railway.json

const url = new URL(window.location.href);
const downloadTemplate = (serverUrl, workspace, layerName) =>
  `${serverUrl}wfs?service=wfs&version=1.1.0&request=GetFeature&typeNames=${workspace}:${layerName}&outputFormat=SHAPE-ZIP`;
const serverUrl = (layerURL) => layerURL.split('rest/')[0];

class LayerInfoApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      layerInfo: undefined,
      termsAccepted: false,
      hideNewWindow: false,
      hideShare: false,
      hidePrint: false,
      layerURL: decodeURIComponent(url.searchParams.get('URL')),
      showDownload: url.searchParams.get('SHOW_DOWNLOAD'),
      requestHeader: undefined,
      params: {},
    };
  }
  componentDidMount() {
    if (this.props.layerURL !== undefined) {
      let layerURL = this.props.layerURL;
      let showDownload = this.state.showDownload;
      let params = {};
      if (this.props.showDownload !== undefined)
        showDownload = this.props.showDownload;
      if (this.props.params !== undefined) params = this.props.params;
      this.setState(
        {
          layerURL: layerURL,
          showDownload: showDownload,
          params: params,
          hideNewWindow: true,
          hideShare: true,
          requestHeader: this.props.requestHeader,
        },
        () => {
          this.getInfo();
        }
      );
    } else {
      this.getInfo();
    }
  }
  // GET LAYER INFO FROM URL
  async getInfo() {
    if (
      this.state.layerURL &&
      this.state.layerURL != 'null' &&
      this.state.layerURL !== ''
    )
      helpers.getJSONWithParams(
        this.state.layerURL,
        this.state.params,
        (response) => {
          if (response.coverage !== undefined) {
            this.setState({ layerInfo: response.coverage });
          } else if (response.featureType === undefined) {
            response['featureType'] = this.parseArcGisFeature(
              response,
              (result) => {
                this.setState({ layerInfo: result });
              }
            );
          } else {
            this.setState({ layerInfo: response.featureType });
          }
        }
      );
  }

  parseFeatureCoverage = (featureInfo, callback) => {
    let featureType = {};
    featureType = featureInfo;
    featureType['attributes'] = {};

    callback(featureType);
  };
  parseArcGisFeature = (featureInfo, callback) => {
    let featureType = {};
    featureType['nativeCRS'] = {};
    featureType.nativeCRS['@class'] = 'Projected';
    if (featureInfo.sourceSpatialReference.wkt === undefined) {
      featureType.nativeCRS[
        '$'
      ] = ` "EPSG:${featureInfo.sourceSpatialReference.latestWkid}`;
    } else {
      if (featureInfo.sourceSpatialReference.wkt.indexOf('GEOGCS') !== -1)
        featureType.nativeCRS['@class'] = 'Geographic';
      featureType.nativeCRS['$'] = featureInfo.sourceSpatialReference.wkt;
    }

    featureType['title'] = featureInfo.name;
    featureType['name'] = featureInfo.name;
    featureType['nativeBoundingBox'] = {};
    featureType.nativeBoundingBox['minx'] = featureInfo.extent.xmin;
    featureType.nativeBoundingBox['maxx'] = featureInfo.extent.xmax;
    featureType.nativeBoundingBox['miny'] = featureInfo.extent.ymin;
    featureType.nativeBoundingBox['maxy'] = featureInfo.extent.ymax;
    let nativeBoundingBoxCrs = {};
    nativeBoundingBoxCrs['@class'] = 'projected';
    nativeBoundingBoxCrs[
      '$'
    ] = `EPSG:${featureInfo.extent.spatialReference.latestWkid}`;
    featureType.nativeBoundingBox['crs'] = nativeBoundingBoxCrs;
    const descriptionObj = layerInfoHelpers.parseESRIDescription(
      featureInfo.description
    );
    featureType['abstract'] = descriptionObj.description;
    featureType['attributes'] = {};
    featureType.attributes['attribute'] = featureInfo.fields.map((item) => {
      return {
        name: item.name,
        binding: item.type.replace('esriFieldType', ''),
      };
    });
    const epsgUrl = (wkt) => `https://epsg.io/${wkt}.wkt`;
    if (featureInfo.sourceSpatialReference.latestWkid === undefined)
      callback(featureType);
    else
      helpers.httpGetText(
        epsgUrl(featureInfo.sourceSpatialReference.latestWkid),
        (projection) => {
          if (projection !== 'ERROR') featureType.nativeCRS['$'] = projection;
          callback(featureType);
        }
      );
  };
  // CLEAN UP THE PROJECTION STRING
  getFormattedProjection = () => {
    let projClass = '';
    if (this.state.layerInfo.nativeCRS['@class'] === undefined) {
      if (this.state.layerInfo.nativeCRS.indexOf('GEOGCS') !== -1)
        projClass = 'Geographic';
      else projClass = 'Projected';
    } else {
      projClass = this.state.layerInfo.nativeCRS['@class'];
    }

    let proj = 'Undefined';
    if (this.state.layerInfo.nativeCRS['$'] === undefined) {
      let projArray = this.state.layerInfo.nativeCRS.split('"');
      proj = helpers.toTitleCase(projClass) + ' - ' + projArray[1];
    } else {
      let projArray = this.state.layerInfo.nativeCRS['$'].split('"');
      proj = helpers.toTitleCase(projClass) + ' - ' + projArray[1];
    }

    //console.log(proj);
    return proj;
  };

  // FORMAT DATE FOR FOOTER
  formatDate() {
    var monthNames = [
      'januar',
      'februar',
      'mart',
      'april',
      'maj',
      'juni',
      'juli',
      'august',
      'septembar',
      'oktobar',
      'novembar',
      'decembar',
    ];

    var date = new Date();
    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    return day + '. ' + monthNames[monthIndex] + ' ' + year + '.';
  }

  onShareClick = () => {
    var mailToSubject = 'Layer Metdata for ' + this.state.layerInfo.title;
    var mailToBody = window.location.href;
    var mailTo = 'mailto:?subject=' + mailToSubject + '&body=' + mailToBody;
    window.location.href = mailTo;
  };

  onTermsChange = (evt) => {
    this.setState({ termsAccepted: evt.target.checked });
  };

  onDownloadClick = (evt) => {
    const workspace = this.state.layerInfo.namespace.name;
    const layerName = this.state.layerInfo.name;
    window.open(
      downloadTemplate(serverUrl(this.state.layerURL), workspace, layerName),
      '_blank'
    );
  };
  render() {
    if (
      this.state.layerInfo === undefined ||
      this.state.layerInfo.nativeCRS === undefined
    )
      return (
        <h3
          className={
            this.state.layerURL == 'null'
              ? 'gli-main-error'
              : 'gli-main-error hidden'
          }
        >
          Error: Layer Not Found or no URL Parameter provided.
        </h3>
      );

    const proj = this.getFormattedProjection();
    let fields = [];
    if (this.state.layerInfo.attributes)
      fields = this.state.layerInfo.attributes.attribute;
    if (!Array.isArray(fields)) fields = [fields];

    const crs = this.state.layerInfo.nativeCRS['$'];
    const boundingBox = this.state.layerInfo.nativeBoundingBox;

    //console.log(showDownload);
    return (
      <div className="fs-layerInfo-main-container">
        <h1
          className={
            this.state.layerURL == 'null'
              ? 'fs-layerInfo-gli-main-error'
              : 'fs-layerInfo-gli-main-error hidden'
          }
        >
          Error: Layer Not Found
        </h1>
        <div className="fs-layerInfo-header">
          <table style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td className="fs-layerInfo-title">
                  {this.state.layerInfo.title}
                </td>
                <td
                  style={{ width: '60px' }}
                  className={this.state.hideShare ? 'hidden' : ''}
                >
                  <img
                    onClick={this.onShareClick}
                    title="Share this page through E-Mail"
                    className={'fs-layerInfo-headerButton'}
                    src={images['share-icon.png']}
                    alt="Share"
                  />
                </td>

                <td style={{ width: '30px', cursor: 'pointer' }}>
                  <img
                    onClick={() => {
                      window.print();
                    }}
                    title="Printaj ovu stranicu"
                    className="fs-layerInfo-headerButton"
                    src={images['print-icon.svg']}
                    alt="Print"
                  />
                </td>
                <td
                  style={{ width: '60px' }}
                  className={this.state.hideNewWindow ? 'hidden' : ''}
                >
                  <img
                    onClick={() => {
                      window.open(window.location.href, '_blank');
                    }}
                    title="Open this page in a new window"
                    className={'fs-layerInfo-headerButton'}
                    src={images['new-window-icon.png']}
                    alt="New Window"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="fs-layerInfo-item-container">
          <fieldset>
            <legend>Opis</legend>
            <div className="fs-layerInfo-item-content">
              {this.state.layerInfo.abstract}
            </div>
          </fieldset>
        </div>

        <div className="fs-layerInfo-item-container">
          <fieldset>
            <legend>Projekcija</legend>
            <div className="fs-layerInfo-item-content">{proj}</div>
          </fieldset>
        </div>

        <div
          className={
            fields.length > 0 ? 'fs-layerInfo-item-container' : 'hidden'
          }
        >
          <fieldset>
            <legend>Atributna polja</legend>
            <div className="fs-layerInfo-item-content-fields">
              {fields.map((fieldInfo) => (
                <FieldItem key={helpers.getUID()} fieldInfo={fieldInfo} />
              ))}
            </div>
          </fieldset>
        </div>

        <div className="fs-layerInfo-footer">
          <div style={{ float: 'left' }}>
            {/* <div>
              <a href={window.config.openLicenseUrl} target="_blank" rel="noopener noreferrer">
                View Terms of Use
              </a>
            </div> */}
            <br />
            {/* <div>
              Layer info page generated using{" "}
              <a href={window.config.originUrl} target="_blank" rel="noopener noreferrer">
                {window.config.originUrl.split("//")[1]}
              </a>{" "}
              interactive mapping.
              <br />
            </div> */}
          </div>
          <div style={{ float: 'right' }}>
            {'Generiran: ' + this.formatDate()}
          </div>
        </div>
      </div>
    );
  }
}

export default LayerInfoApp;

// IMPORT ALL IMAGES
const images = importAllImages(
  require.context('./images', false, /\.(png|jpe?g|svg|gif)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
}

function FieldItem(props) {
  const fieldInfo = props.fieldInfo;
  const name = fieldInfo.name;
  const dataTypeArray = fieldInfo.binding.split('.');
  const dataType = dataTypeArray[dataTypeArray.length - 1];

  return (
    <div style={{ margin: '5px' }}>
      <b>{name}</b>
      {' ( ' + dataType + ' )'}
    </div>
  );
}
